import React, {useContext, useEffect, useRef, useState} from 'react';
import UniversalComplexInput from 'components/universal/input/UniversalComplexInput';
import {postMessageRequest} from 'util/api';
import {usePopup} from 'popup/PopupContext';
import {UserContext} from 'components/user/UserContext';
import AddMoneyPopupWrapper from 'components/donate/AddMoneyPopupWrapper';

const ChatInput = ({unitPrice, onSendMessage, onHeightResize}) => {
    const {user} = useContext(UserContext);
    const {openPopup} = usePopup();
    const [inputLength, setInputLength] = useState(0);
    const [sendAmount, setSendAmount] = useState(0);
    const [prevUnitPrice, setPrevUnitPrice] = useState(unitPrice);

    const universalComplexInputRef = useRef();

    useEffect(() => {
        console.log('inputLength:', inputLength);
        // Recalculate sendAmount when inputLength or unitPrice changes
        setSendAmount(Math.floor(inputLength / 10 + 1) * unitPrice);
    }, [inputLength, unitPrice]);

    useEffect(() => {
        if (prevUnitPrice !== unitPrice) {
            if (unitPrice > prevUnitPrice) {
                // Price increased
                universalComplexInputRef.current?.priceIncreased();
            } else if (unitPrice < prevUnitPrice) {
                // Price decreased
                universalComplexInputRef.current?.priceDecreased();
            }
            setPrevUnitPrice(unitPrice);
        }
    }, [unitPrice, prevUnitPrice]);

    const handleSendMessageRequest = ({
                                          inputValue,
                                          sendAmount,
                                          onSuccess,
                                          onError,
                                          setIsInputDisabled
                                      }) => {
        if (sendAmount > user.balance) {
            openPopup(<AddMoneyPopupWrapper initialAmount={sendAmount - user.balance}/>);
            return;
        }

        setIsInputDisabled(true);

        postMessageRequest(inputValue, sendAmount, user.balance).then(
            () => {
                onSendMessage();
                onSuccess();
            },
            (error) => {
                onError(error);
            }
        );
    };

    const handleInputLengthChange = (length) => {
        setInputLength(length);
    };

    return (
        <UniversalComplexInput
            ref={universalComplexInputRef}
            sendAmount={sendAmount}
            onHeightResize={onHeightResize}
            onSendMessageRequest={handleSendMessageRequest}
            onInputLengthChange={handleInputLengthChange}
        />
    );
};

export default ChatInput;
